import { DialogTitle } from '@headlessui/react';
import { forwardRef, JSX } from 'react';

import { CloseIcon } from '~components/icons/CloseIcon';
import { Job } from '~extension/web2print/model/Job';
import { DownloadFormatList } from '~extension/web2print/view/MyFiles/DownloadFormatList';
import { Button } from '~modules/media-library/view/Button';

type MyFilesModalPanelProps = {
  myFilesJob: Job;
  onClose?: () => void;
};

export const MyFilesModalPanel = forwardRef<HTMLDivElement, JSX.IntrinsicElements['div'] & MyFilesModalPanelProps>(
  function MyFilesModalPanel({ onClose, myFilesJob, className, ...TheirProps }, ref) {
    return (
      <div
        className={`ml--detail-modal--panel bg-white overflow-y-auto rounded-md shadow-xl w-full max-w-lg min-h-0 max-h-full flex flex-col relative ${
          className ? className : ''
        }`}
        {...TheirProps}
        ref={ref}
      >
        <header className="ml--download-modal--panel-header flex px-3 py-2 border-solid border-gray border-b-2">
          <DialogTitle
            as="h2"
            className="ml--download-modal--title font-semibold text-base leading-snug overflow-hidden overflow-ellipsis p-0 m-0"
          >
            MyFiles
          </DialogTitle>
        </header>
        <Button variant="icon" className="absolute top-0 right-0 border-none" onClick={onClose}>
          <CloseIcon />
        </Button>

        <div className="flex flex-col gap-3 p-3">
          <DownloadFormatList myFilesJob={myFilesJob} />
        </div>
      </div>
    );
  },
);
